import apiClient from '../../api/http-common';

export interface INewsletterData {
  data: {
    filtered: number;
    rows: any[];
    total: number;
  }
}

export interface ILanguage {
  id: number;
  code: string;
  order: number;
  label: string;
}

export interface Type {
  key: string;
  label: string;
}

export interface INewsletterOptionsResponse {
  data: {
    languages: ILanguage[];
    types: Type[];
  }
}

const getNewsletterIndex = (data?): any =>
  apiClient.post<INewsletterData>('/newsletter/index', data)

const createNewsletter = (data?): any =>
  apiClient.post('/newsletter/store', data)

const getNewsletterOptions = (): Promise<INewsletterOptionsResponse> =>
  apiClient.post('/newsletter/get-options-data');

const countNewNewsletter = () =>
  apiClient.post('/newsletter/count-new');

const getNewsletterRecipients = (data?): any =>
  apiClient.post('/newsletter/get-recipients', data)

const getNewsletterRecipientsById = (id: string): any =>
  apiClient.post(`/newsletter/${id}/get-recipients`)

const editNewsletter = (id: string): any =>
  apiClient.post(`/newsletter/${id}/edit`)

const deleteNewsletter = (id: string): any =>
  apiClient.post(`/newsletter/${id}/delete`)

const showNewsletter = (id: string): any =>
  apiClient.post(`/newsletter/${id}/show`)

const updateNewsletter = (id: string, data): any =>
  apiClient.post(`/newsletter/${id}/update`, data)

const getFileNewsletter = (id: string, data): any =>
  apiClient.post(`/newsletter/${id}/get-file`, data)

const getPreviewNewsletter = (id: string): any =>
  apiClient.post(`/newsletter/${id}/preview`)

const NewsletterService = {
  getNewsletterIndex,
  createNewsletter,
  getNewsletterOptions,
  getNewsletterRecipients,
  editNewsletter,
  updateNewsletter,
  showNewsletter,
  getNewsletterRecipientsById,
  deleteNewsletter,
  getFileNewsletter,
  getPreviewNewsletter,
  countNewNewsletter
};

export default NewsletterService;
